module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "setClass": ['no-padding'],
      "width": "500px"
    },
    on: {
      "close": _vm.closeLocalModal
    }
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: {
      header: true, disabled: _vm.loading
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.school.full_title || _vm.school.subtitle))]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [(!_vm.params.activity) ? _c('div', [_c('icon', {
    attrs: {
      "name": "calendar-blue",
      "scale": 1.1
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('general.days-count')) + ":")]), _vm._v(" " + _vm._s(_vm.school.actual_days) + " " + _vm._s(_vm.$t('general.days')))], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('icon', {
    attrs: {
      "name": "clock",
      "scale": 1.1
    }
  }), _vm._v(" " + _vm._s(_vm.school.minutes) + _vm._s(_vm.$t('general.minutes-short'))), (!_vm.params.activity) ? _c('span', [_vm._v("/" + _vm._s(_vm.$t('skischool.lesson')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "location"
  }, [_c('div', {
    staticClass: "label",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.openModal(['SkiSchoolLocationMap'])
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skischool.gathering-site')) + " "), _c('icon', {
    attrs: {
      "name": "info-blue-white-bg",
      "scale": 1.3
    }
  })], 1), _vm._v(" "), _c('div', [(_vm.SITE_CONFIG.skischool.show_site) ? _c('div', {
    staticClass: "location-box"
  }, [(_vm.school.site === 2) ? _c('strong', [_c('icon', {
    attrs: {
      "name": "berget",
      "scale": 1.6
    }
  }), _vm._v(" " + _vm._s(_vm.school.site_name))], 1) : _vm._e(), _vm._v(" "), (_vm.school.site === 1) ? _c('strong', [_c('icon', {
    attrs: {
      "name": "byn",
      "scale": 1.6
    }
  }), _vm._v(" " + _vm._s(_vm.school.site_name))], 1) : _vm._e(), _vm._v(" "), (!_vm.school.site) ? _c('strong', [_c('icon', {
    attrs: {
      "name": "gondol",
      "scale": 1.6
    }
  }), _vm._v(" " + _vm._s(_vm.school.site_name))], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skischool.branas.site-this-school', {
    site: _vm.school.site_name_help
  })))]), _vm._v(" "), (_vm.showMinParticipantsReq) ? _c('p', [_vm._v(_vm._s(_vm.groupParticipantsRequirementText))]) : _vm._e(), _vm._v(" "), (_vm.lowParticipantCountVariations && _vm.SITE_CONFIG.site === 'branas') ? _c('p', [_vm._v(_vm._s(_vm.lowParticipantCountVariationText))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.skischool.show_site) ? _c('div', {
    staticClass: "location-box"
  }, [(_vm.$route.name === 'ski school overview') ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('skischool.kungsberget.site.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skischool.kungsberget.site.description')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skischool.kungsberget.site-help')))])]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'bike school overview') ? _c('div', [_c('strong', [_vm._v("Bron")]), _vm._v(" "), _c('p', [_vm._v("Vi samlas på bron mellan hyran och 8stols liften.")]), _vm._v(" "), _c('p', [_vm._v("Cykel och skyddsutrustning ingår ej i aktivitetsbokningen, men kan förbokas på "), _c('a', {
    attrs: {
      "href": "https://hyra.kungsberget.se"
    }
  }, [_vm._v("hyra.kungsberget.se")]), _vm._v(". Som deltagare tar du själv med dig liftkort.")]), _vm._v(" "), _c('p', [_vm._v("Kungsberget förbehåller sig rätten att vid 2 elever eller färre, ställa in kursen eller erbjuda ett annat kurstillfälle.")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.school.notice) ? _c('div', {
    staticClass: "location"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Viktig information")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "location-box notice"
  }, [_c('p', [_vm._v(_vm._s(_vm.school.notice))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      main: true, disabled: _vm.loading
    }
  }, [_c('div', {
    staticClass: "field size-75"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('general.pick-startdate'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "label": _vm.theBooking.theDate ? (_vm.moment(_vm.theBooking.theDate).format('D MMMM')) : _vm.$t('general.pick-startdate'),
      "bold-label": false,
      "validated": _vm.theBooking.theDate
    },
    on: {
      "clicked": _vm.openDateModal,
      "clicked-suffix": _vm.dateClear
    }
  })], 1), _vm._v(" "), (!_vm.$route.query.qty) ? _c('div', {
    class: {
      field: true, 'size-25': true, 'fully-disabled': !_vm.theBooking.theDate
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('general.number'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "combo": false,
      "options": _vm.options,
      "valuebinder": _vm.qty,
      "validated": _vm.theBooking.people.length && _vm.qty && _vm.theBooking.theDate
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.qty = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.theBooking.theDate) ? _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('general.pick-time')))]), _vm._v(" "), _c('div', {
    staticClass: "checkboxes"
  }, _vm._l((_vm.times), function(time) {
    return _c('div', [_c('Checkbox', {
      attrs: {
        "label": time.title,
        "label-position": "after",
        "value": time.value,
        "valuebinder": _vm.theBooking.time
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(_vm.theBooking, "time", $event)
        },
        "click": _vm.checkAvailability
      }
    })], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.available) ? _c('div', {
    staticClass: "error"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.reason)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.restrictionDateInfo) ? _c('div', {
    staticClass: "info"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.restrictionDateInfo)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.bookingWarning) ? _c('div', {
    staticClass: "info"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.bookingWarning)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.alreadyBooked) ? _c('div', {
    staticClass: "info"
  }, [_c('div', [_c('b', [_vm._v("Flera elever")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "location-box notice"
  }, [_c('p', [_vm._v(_vm._s(_vm.alreadyBookedMessage))])])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _vm._l((_vm.theBooking.people), function(person, index) {
    return (!_vm.$route.query.qty) ? _c('div', {
      staticClass: "field flex"
    }, [_c('div', {
      staticClass: "field size-75"
    }, [(_vm.theBooking.people.length == 1) ? _c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('general.name-on')) + " " + _vm._s(_vm.school.maxage <= 11 ?
      (_vm.$t('general.ages.the-child')) :
      (_vm.school.maxage >= 17 ? _vm.$t('general.the-skier') : _vm.$t('general.youth')))), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]) : _c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('general.name-on')) + " " + _vm._s(_vm.school.maxage <= 11 ?
      (_vm.$t('general.ages.child')) :
      (_vm.school.maxage >= 17 ? _vm.$t('general.skier') : _vm.$t('general.skier'))) + " " + _vm._s(index + 1)), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (person.name),
        expression: "person.name"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('general.first-and-surname')
      },
      domProps: {
        "value": (person.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field size-25"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t('general.age'))), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": true,
        "options": _vm.ages,
        "valuebinder": person.age,
        "validated": person.age !== '' && (person.age >= _vm.school.minage && person.age <= _vm.school.maxage),
        "label": _vm.$t('general.age')
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "age", $event)
        }
      }
    })], 1), _vm._v(" "), (_vm.showComments) ? _c('div', {
      staticClass: "field"
    }, [_c('div', [_c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between",
        "align-items": "center"
      }
    }, [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.title'))), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), (_vm.getWishesAsList(person.wishes).length) ? _c('button', {
      staticClass: "white small border",
      staticStyle: {
        "margin-top": "14px"
      },
      on: {
        "click": function (e) { return _vm.openWishes(index); }
      }
    }, [_c('icon', {
      attrs: {
        "name": "edit-blue",
        "scale": 1
      }
    }), _vm._v("\n              Ändra\n            ")], 1) : _vm._e()]), _vm._v(" "), (_vm.getWishesAsList(person.wishes).length) ? _c('div', [_c('ul', {
      staticStyle: {
        "margin-top": "0.5rem"
      }
    }, _vm._l((_vm.getWishesAsList(person.wishes)), function(wish) {
      return _c('li', {
        key: wish
      }, [_vm._v(_vm._s(wish))])
    }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.getWishesAsList(person.wishes).length) ? _c('div', [_c('p', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v("När du bokar privatlektion uppskattar vi om du anger önskemål.")]), _vm._v(" "), _c('button', {
      staticClass: "small border",
      on: {
        "click": function (e) { return _vm.openWishes(index); }
      }
    }, [_c('icon', {
      attrs: {
        "name": "plus-white",
        "scale": 1
      }
    }), _vm._v("\n              " + _vm._s(_vm.$t('skirental.wishes.add')) + "\n            ")], 1)]) : _vm._e()])]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.theBooking.people.length && !_vm.$route.query.qty) ? _c('hr', {
    staticStyle: {
      "width": "100%"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGuardian && (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn')) ? _c('div', {
    staticClass: "field"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('general.name-guardian'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theBooking.guardian),
      expression: "theBooking.guardian"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('general.first-and-surname')
    },
    domProps: {
      "value": (_vm.theBooking.guardian)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.theBooking, "guardian", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('general.phone'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theBooking.phone),
      expression: "theBooking.phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "placeholder": _vm.$t('general.phone-number')
    },
    domProps: {
      "value": (_vm.theBooking.phone)
    },
    on: {
      "blur": _vm.fixPhone,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.theBooking, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-number"
  }, [_vm._v(_vm._s(_vm.$t('general.obs-format', {
    format: '+46701234567'
  })))])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "info-call",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('general.special-needs-call', {
        phone: ("<b>" + _vm.bookingNumber + "</b>")
      }))
    }
  }), _vm._v(" "), (_vm.showMinParticipantsReq && _vm.SITE_CONFIG.site === 'branas') ? _c('p', {
    staticClass: "info-group-requirements"
  }, [_vm._v(_vm._s(_vm.groupParticipantsRequirementText))]) : _vm._e()], 2), _vm._v(" "), (!_vm.loadingAvailability) ? _c('div', {
    class: {
      footer: true, disabled: _vm.loading
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.params.activity) ? _c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.$t('general.price-per-person')) + " "), _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.price)))])]) : _vm._e(), _vm._v(" "), (_vm.params.activity) ? _c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.$t('general.price')) + ": "), _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.price, {
    freeIfZero: true
  })))])]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": !_vm.validated()
    },
    on: {
      "click": function($event) {
        return _vm.addToCart()
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.isOnSite ? _vm.$t('general.pay-with-card') : _vm.$t('general.cta.book')) + " "), (!_vm.$store.state.isOnSite) ? _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.4
    },
    on: {
      "click": _vm.addToCart
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      footer: true, disabled: _vm.loading
    },
    staticStyle: {
      "padding-top": "0"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "width": "100%"
    }
  }, [(_vm.$store.state.isOnSite) ? _c('button', {
    class: 'small white border',
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "disabled": !_vm.validated()
    },
    on: {
      "click": function($event) {
        return _vm.openCodeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.pay-cash')))]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13c90824"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiSchoolBooking.vue
// module id = 919
// module chunks = 0